import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import PageHeader from "@/components/UI/PageHeader.vue";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import DataOffers from "@/data/AdminPanel/DataOffers";
import ApiEnter from "@/api/ApiEnter";
import ApiOffer from "@/api/ApiOffer";
import sweetalert from "sweetalert";
import ApiAdmin from "@/api/ApiAdmin";
import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";
import CKEditor from "@/data/CKeditor/config";
import { EIncludeTariffs } from "@/struct/offers/EIncludeTariffs";
import ApiRegion from "@/api/ApiRegion";
let OfferCreate = class OfferCreate extends Vue {
    constructor() {
        super(...arguments);
        this.editor = ClassicEditor;
        this.HasLoading = false;
        this.editorConfig = CKEditor.editorConfig(ApiEnter.CurrentSessionUUID);
        this.Breadcrumbs = DataOffers.OfferCreateBreadcrumbs;
        this.OffersCategories = [];
        this.newOffer = {
            name: "",
            priority: "",
            publish: true,
            deprecated: false,
            price: "",
            renewalPrice: "",
            discountPrice: "",
            duration: 1,
            additional_price_info: "",
            sticker_text: "",
            data: "",
            sms: "",
            min: "",
            additional_data: "",
            overview: "",
            note: "",
            display_for_new: false,
            display_for_current: false,
            prospects_info: null,
            title: "",
            description: "",
            additional_description: "",
            selectedTariffs: [],
            keywords: "",
            url: "",
            facility_id: null,
            operator: "",
        };
        this.tariffItems = [
            {
                text: "Бесплатный Транспорт",
                value: EIncludeTariffs.FreeTransport,
            },
            {
                text: "Бесплатные Cоц. сети",
                value: EIncludeTariffs.FreeSocials,
            },
            {
                text: "Бесплатные Мессенджеры",
                value: EIncludeTariffs.FreeMessengers,
            },
            {
                text: "Бесплатная Музыка",
                value: EIncludeTariffs.FreeMusik,
            },
            {
                text: "Бесплатное Видео",
                value: EIncludeTariffs.FreeVideo,
            },
        ];
        this.emsOffers = [];
        this.selectOffer = null;
        this.emsOffer = null;
        this.filteredOfferOperators = [];
        this.selectRegion = null;
        this.selectedFacility = null;
        this.defaultRegion = null;
        this.regionItems = [];
    }
    async getCMSRegions() {
        this.HasLoading = true;
        try {
            const regions = await ApiRegion.GetRegions();
            this.regionItems = regions.map((item) => ({
                name: item.display_name,
                facility_id: item.facility_id,
                default: item.default,
            }));
            this.defaultRegion =
                this.regionItems.find((item) => item.default === 1) || null;
            if (this.defaultRegion) {
                this.selectRegion = this.defaultRegion.facility_id;
            }
        }
        catch (e) {
            console.error(e);
        }
        this.HasLoading = false;
    }
    async getOfferOperators() {
        this.HasLoading = true;
        try {
            const operators = await ApiOffer.GetOfferOperators(ApiEnter.CurrentSessionUUID);
            if (operators) {
                this.filteredOfferOperators = operators.filter((operator) => !operator.is_archived);
            }
        }
        catch (e) {
            console.error(e);
        }
        this.HasLoading = false;
    }
    Translit(str) {
        let ru = "А-а-Б-б-В-в-Ґ-ґ-Г-г-Д-д-Е-е-Ё-ё-Є-є-Ж-ж-З-з-И-и-І-і-Ї-ї-Й-й-К-к-Л-л-М-м-Н-н-О-о-П-п-Р-р-С-с-Т-т-У-у-Ф-ф-Х-х-Ц-ц-Ч-ч-Ш-ш-Щ-щ-Ъ-ъ-Ы-ы-Ь-ь-Э-э-Ю-ю-Я-я".split("-");
        let en = "A-a-B-b-V-v-G-g-G-g-D-d-E-e-E-e-E-e-ZH-zh-Z-z-I-i-I-i-I-i-J-j-K-k-L-l-M-m-N-n-O-o-P-p-R-r-S-s-T-t-U-u-F-f-H-h-TS-ts-CH-ch-SH-sh-SCH-sch-'-'-Y-y-'-'-E-e-YU-yu-YA-ya".split("-");
        let res = "";
        for (let i = 0, l = str.length; i < l; i++) {
            let s = str.charAt(i), n = ru.indexOf(s);
            if (n >= 0) {
                res += en[n];
            }
            else {
                res += s;
            }
        }
        return res;
    }
    GenerateSeoUrl() {
        let url = this.Translit(this.newOffer.name.replace(/[\s]+/gi, "-"));
        this.newOffer.url = url.replace(/[^0-9a-z_-]+/gi, "").toLowerCase();
    }
    filterOffer() {
        this.emsOffer = this.emsOffers.find((item) => item.id === this.selectOffer);
    }
    filterRegion() {
        if (this.selectRegion) {
            const selectedRegion = this.regionItems.find((item) => item.facility_id === this.selectRegion);
            if (selectedRegion) {
                this.selectedFacility = selectedRegion.facility_id;
                this.getCMSOffers(this.selectedFacility);
            }
        }
        else {
            this.selectedFacility = parseInt(process.env.VUE_APP_FACILITY_ID);
            this.getCMSOffers(this.selectedFacility);
        }
    }
    ValidateSeoUrl() {
        this.newOffer.url = this.Translit(this.newOffer.url.replace(/[. ,$@!^()'*]+/g, "-").toLowerCase());
    }
    async getOffersCategories() {
        try {
            this.OffersCategories = await ApiOffer.GetOfferCategories(ApiEnter.CurrentSessionUUID);
        }
        catch (e) {
            console.error(e);
        }
    }
    async OnClickSubmit() {
        // this.HasLoading = true;
        if (ApiEnter.CurrentSessionUUID != undefined) {
            this.$forceUpdate();
            let service = this.tariffItems.filter((item) => this.newOffer.selectedTariffs.includes(item.value));
            if (service.length === 0) {
                service = [];
            }
            const offer_uuid = await ApiOffer.CreateOffer(ApiEnter.CurrentSessionUUID, this.newOffer.name, this.newOffer.priority, this.newOffer.publish ? 1 : 0, this.newOffer.deprecated ? 1 : 0, this.newOffer.price, this.newOffer.data, this.newOffer.sms, this.newOffer.min, this.newOffer.additional_data, this.newOffer.additional_price_info, this.newOffer.sticker_text, this.newOffer.overview, this.newOffer.note, this.newOffer.display_for_new ? 1 : 0, this.newOffer.display_for_current ? 1 : 0, this.newOffer.prospects_info != null
                ? (await ApiAdmin.UploadFile(ApiEnter.CurrentSessionUUID, this.newOffer.prospects_info))
                : "", this.newOffer.title, this.newOffer.description, this.newOffer.additional_description, this.emsOffer ? this.emsOffer?.id : null, this.emsOffer ? this.emsOffer?.name : null, this.newOffer.keywords, this.newOffer.url, JSON.stringify(service), this.newOffer.renewalPrice, this.newOffer.discountPrice || null, Number(this.newOffer.duration) || 1, this.selectedFacility
                ? this.selectedFacility
                : parseInt(process.env.VUE_APP_FACILITY_ID), this.newOffer.operator);
            if (offer_uuid == undefined || offer_uuid.length != 36) {
                await sweetalert({
                    title: this.$t("general.error"),
                    text: this.$t("general.request_error"),
                    icon: "info",
                });
                return;
            }
            sweetalert({
                title: this.$t("general.success"),
                text: this.$t("general.success_created"),
                icon: "success",
            }).then(() => {
                this.$forceUpdate();
                this.$router.push(`/secure/shop/offers`);
            });
        }
        this.HasLoading = false;
    }
    async getCMSOffers(facility_id) {
        try {
            const response = await ApiOffer.GetEMSOffers(ApiEnter.CurrentSessionUUID, "main", facility_id || process.env.VUE_APP_FACILITY_ID);
            if (typeof response != "boolean") {
                this.emsOffers = response;
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    created() {
        this.getOffersCategories();
        this.getCMSRegions();
        this.getCMSOffers(this.selectedFacility);
        this.getOfferOperators();
    }
};
OfferCreate = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], OfferCreate);
export default OfferCreate;
